//渠道控制！！！！
import {validatenull} from '@/util/validate'
import {isFgkDianti, isFgkDoor} from '@/util/productUtil'
import store from '@/store'

//enum
export const EnumChannelType = {
	mbFgk: 'mbFgk',
	hekang: 'hekang',
	bowei: 'bowei',
	jitai: 'jitai',
}

/**
 * 渠道控制！！！！
 */
//目前已知，韦锋渠道 ，合康渠道， 吉泰
const channelDif = {
	//韦锋渠道
	[EnumChannelType.mbFgk]: {
		channelName: EnumChannelType.mbFgk,
		//是否全屏
		isFullScreen: true,
	},
	//合康渠道
	[EnumChannelType.hekang]: {
		channelName: EnumChannelType.hekang,
		//是否全屏
		isFullScreen: true,
	},
	//博维
	[EnumChannelType.bowei]: {
		channelName: EnumChannelType.bowei,
		//是否全屏
		isFullScreen: true,
		//需要处理userInfo
		handleUserInfo: true,
	},
	//吉泰
	[EnumChannelType.jitai]: {
		channelName: EnumChannelType.jitai,
		//是否全屏
		isFullScreen: false,
	},
	/**
	 * 通用的方法
	 */
	getDifChannelAppId,
}

export default channelDif

//代客计划书过来的接口特殊处理 appid

const urlList = ['/v2/config', 'insure/verify_holder', '/v2/calc_apply']

//有的方法需要根据渠道控制
/**
 * 获取渠道appid
 * @param {string} url 请求地址
 * @returns {string} appid
 */
function getDifChannelAppId(url = '') {
	let appId = ''
	//是否需要传递appid
	let {channelName = '', appId: externalAppId = ''} = store.getters.difChannelType || {}
	let isFind = urlList.find((item) => url.indexOf(item) !== -1)
	if (channelName && externalAppId && externalAppId != 1 && (channelName != 'mbFgk' || isFind)) {
		console.log(`需要传递appId-------${channelName}----`, externalAppId)
		appId = externalAppId
	}
	return appId
}

/**
 *
 * @returns 判断iframe 是否嵌套
 */
export function isIframe() {
	return window.top !== window.self
}

//message 事件类型
export const MessageEventType = {
	initError: 'initError',
	anzeCheck: 'anzeCheck',
	policyDetail: 'policyDetail',
	xsmChange: 'xsmChange',
	payUrl: 'payUrl',
	changeSuccess: 'changeSuccess',
	//被保险人
	insuredResult: 'insuredResult',
}

//如果是内嵌则发消息给父类处理，否则执行方法
//initError
//let {msgType} = msgData
export function sendMsgToParent(msgData, func) {
	console.log('sendMsgToParent------', isIframe(), msgData)
	if (isIframe()) {
		window.parent.postMessage(msgData, '*')
	} else {
		func && func()
	}
}

//判断渠道类型
export function getChannelType(fn) {
	let isMainChannel = false
	let {distAccount = {}} = store.getters.userInfo || {}
	if (!validatenull(distAccount)) {
		if (fn(distAccount)) {
			//类型
			isMainChannel = true
		}
	}
	return isMainChannel
}

//判断是否为渠道
export function isChannel() {
	return getChannelType(({id, channelId}) => id && channelId)
}

//是否为主渠道，和主渠道内勤
export function isMainChannelAndInner() {
	return getChannelType(
		({channelId = '', mainChannelId = ''}) => channelId && mainChannelId && channelId === mainChannelId,
	)
}

//是否为子渠道
export function isZiChannel() {
	return getChannelType((channelId, role) => channelId && role === 5)
}

//是否为主渠道
export function isMainChannel() {
	return getChannelType(({channelId = '', mainChannelId = '', role}) => channelId && mainChannelId && role === 4)
}

//判断是否为管理员，或者超级管理员
export function isFxadminChannel() {
	return !getChannelType(({channelId}) => channelId)
}

//判断是否为体验账号
export function isExperienceChannel() {
	return getChannelType(({accountType}) => accountType === 2)
}

//获取主渠道手机号
export function getMainChannelMobile() {
	let {distAccount: {channelMobile = ''} = {}} = store.getters.userInfo || {}
	return channelMobile
}

//获取主渠道ID
export function getMainChannelId() {
	let {id = ''} = store.getters.userInfoMain || {}
	return id
}

/**
 * 门窗
 */

// let isShowDoor = ['15883832102','18752004865', '18826409689']
let isShowFgkDoor = ['1']

/**
 * IEB-1218
 * 1、全开渠道:浙江杭州陈桂根(分销)、上海甘霖(分销)、上海电梯文化(分销)、河北石家庄易梯（分销）、广东深圳特安保（分销）
 * 2、(1、3个月开，6个月、年单不开)渠道:河南郑州王晓东(分销)、河北邢台宋效铭(分销)、山东济南刘通(分销)
 * 其他渠道无法看到太保电梯
 */

let isAnzeDiantiAll = ['5809', '11693']
let isAnzeDiantiNoYear = []
let isAnzeDiantiNoSixYear = ['115', '260', '339']

let isShowAnzeDianti = ['5809', '11693', '16273', '17615', '16451', '2']

let isShowGuZhuHaoHua = ['260', '115', '339', '2']

//获取channelIds
export function getChannelIds() {
	let {distAccount = {}} = store.getters.userInfo
	if (!validatenull(distAccount)) {
		let {mainChannelId = ''} = distAccount
		if (mainChannelId !== '') {
			return mainChannelId
		}
	}
	return ''
}

// /**
//  * 控制特定渠道产品！！
//  */
// export function isShowProductControl(insureType, productId, title = '') {
// 	//获取渠道数据
// 	let mainChannelId = getChannelIds()
// 	if (mainChannelId !== '' && process.env.NODE_ENV !== 'development') {
// 		//门窗只有特定渠道可见!! 取消
// 		if (isFgkDoor(productId)) {
// 			return !isShowFgkDoor.includes(mainChannelId)
// 		} else if (isFgkDianti(insureType)) {
// 			return isShowAnzeDianti.includes(mainChannelId)
// 		} else {
// 			return true
// 		}
// 	}
// 	return true
// }

/**
 * 处理太保电梯，可选方案
 */
export function getFgkDiantiPeriod(periodList = [], insureType) {
	if (isFgkDianti(insureType)) {
		//获取渠道数据
		let mainChannelId = getChannelIds()
		if (mainChannelId !== '') {
			periodList =
				periodList.filter(({value}) => {
					if (isAnzeDiantiNoSixYear.includes(mainChannelId)) {
						return !value.includes('6') && !value.includes('12')
					} else if (isAnzeDiantiNoYear.includes(mainChannelId)) {
						return !value.includes('12')
					} else {
						return true
					}
				}) || []
		}
	}
	return periodList
}
